import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { TYPE } from '@/lib/typography';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('min-w-0 rounded-card bg-ds-card p-s4 shadow-card nav:p-s5', className)}
      {...props}
    />
  );
}

export function CardHeader({
  title,
  action,
  count,
  className,
}: {
  title: ReactNode;
  action?: ReactNode;
  count?: number;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-s3', className)}>
      <h2 className={cn(TYPE.heading, 'min-w-0 flex-1 text-ds-text')}>{title}</h2>
      {count != null ? (
        <span
          className={cn(
            TYPE.meta,
            'inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-ds-neutral-tint px-s2 text-ds-muted',
          )}
        >
          {count}
        </span>
      ) : null}
      {action}
    </div>
  );
}

export function ListRow({
  className,
  children,
  rail,
  ...props
}: HTMLAttributes<HTMLDivElement> & { rail?: 'draft' | 'finalized' | 'cancelled' }) {
  const railClass =
    rail === 'finalized'
      ? 'before:bg-ds-teal'
      : rail === 'cancelled'
        ? 'before:bg-ds-line-strong'
        : rail === 'draft'
          ? 'before:bg-ds-teal-line'
          : null;

  return (
    <div
      className={cn(
        'relative flex items-center gap-s4 border-b border-ds-line px-s4 py-s4 last:border-b-0',
        rail &&
          'before:absolute before:inset-y-0 before:left-0 before:w-1 before:rounded-l-card before:content-[""]',
        railClass,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
